<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <b-form @submit="onSubmit">
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col">
                <label>Wybrany młyn:</label>
                <v-select label="name" :options="mills" v-model="form.millId" :reduce="(x) => x.id"
                  :disabled="true"></v-select>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col">
                <label>Nazwa kuwertury</label>
                <input type="text" class="form-control" disabled="true" v-model="couvertureName" />
              </div>
            </div>
          </div>
          <div class="col">
            <DisplayRecepies @selectedRecepie="SetName"></DisplayRecepies>
            <div class="alert alert-danger" v-if="this.formError && this.formError.recipeId">
              {{ this.formError.recipeId }}
            </div>
          </div>
        </div>
        <hr />
        <div class="row grid-padding-10">
          <div class="col-10">
            <h3>Wybrane kuwertury do zmieszania</h3>
          </div>
          <div class="col-2">
            <button type="button" class="btn btn-primary float-right" @click="AddNextItem">
              Dodaj kuwerturę
            </button>
          </div>
        </div>
        <div class="alert alert-danger" v-if="this.formError && this.formError.couverturesToMix">
          {{ this.formError.couverturesToMix }}
        </div>
        <MixCouveturesFromShelfSingleItem v-for="item in form.couverturesToMix" :key="item.id"
          v-model="form.couverturesToMix" @mixCouvertureItemDelete="RemoveItem" :item="item">
        </MixCouveturesFromShelfSingleItem>

        <div class="row">
          <div class="col align-self-end div-form-buttons-area">
            <button type="submit" class="btn-primary btn">Zapisz</button>
            <button type="button" class="btn-warning btn" @click="$router.go(-1)">
              Anuluj
            </button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Loading from "../Common/Loading";
import urlConfig from "../../mixins/url";
import DisplayRecepies from "./DisplayRecepies";
import MixCouveturesFromShelfSingleItem from "./MixCouveturesFromShelf_SingleItem";
import CouvertureService from "../../services/couverture.service";

export default {
  components: { Loading, DisplayRecepies, MixCouveturesFromShelfSingleItem },
  mixins: [urlConfig],
  computed: {
    mills() {
      return this.$store.state.couvertureFormData.mills;
    },
  },
  mounted() {
    this.$store.dispatch("getCuvertureFormData");
    this.form.millId = parseInt(this.$route.params.millId);
    this.isLoaded = true;
  },
  data() {
    return {
      isLoaded: false,
      millId: undefined,
      couvertureName: "",
      counter: 2,
      formError: {},
      form: {
        couverturesToMix: [{ id: 1 }, { id: 2 }],
        millId: undefined,
        recipeId: undefined,
      },
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      this.FormValidation();
      var errorsCount = Object.keys(this.formError).length;
      if (errorsCount == 0) {
        var that = this;
        var dataToSend = {
          recipeId: this.form.recipeId,
          millId: this.form.millId,
          couverturesToMix: this.form.couverturesToMix.map((c) => ({
            couvertureId: c.couverture.id,
            couvertureWeightToTake: c.weight,
          })),
        };

        CouvertureService.mixCouverturesFromShelf(dataToSend)
          .then(() => {
            that.$router.push("/Mlyny");
          })
          .catch((err) => {
            var ref = that.$refs.loadingSpinner;
            ref.ShowErrorMessage(err);
            this.DisplayError("Błąd", "Nie udało się wymieszać kuwertur");
          });
      }
    },
    FormValidation() {
      this.formError = {};
      if (!this.form.recipeId) {
        this.formError.recipeId = "Należy wybrać recepturę";
      }

      if (this.form.couverturesToMix.length < 2) {
        this.formError.couverturesToMix =
          "Należy wybrać co najmniej dwie receptury";
      } else {
        this.form.couverturesToMix.forEach((x) => {
          if (!x.couverture) {
            this.formError.couverturesToMix =
              "Nie wszędzie kuwertura została wybrana";
          }
          if (x.couverture && !x.isValid) {
            this.formError.couverturesToMix = "Jedna z kuwertur ma błędne dane";
          }
        });
      }
    },
    SetName(recipe) {
      if (recipe) {
        this.couvertureName = recipe.name;
        this.form.recipeId = recipe.id;
        this.formError.recipeId = undefined
      } else {
        this.couvertureName = "";
        this.form.recipeId = 0;
        this.formError.recipeId = "Należy wybrać recepturę";
      }
    },
    AddNextItem() {
      this.counter = this.counter + 1;
      this.form.couverturesToMix.push({ id: this.counter });
    },
    RemoveItem(id) {
      this.form.couverturesToMix = this.form.couverturesToMix.filter(
        (x) => x.id != id
      );
    },
  },
};
</script>